import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { CartSettingContent, CartSettingSwitchItem, CartSettingSwitchWrap, CartSettingTitle } from '../index.styled'
import SwitchInputControlled from '../../../Elements/inputs/SwitchInput/controlled'
import { businessScopeConfig, DELIVERY_MODULE } from '../../constants'
import { updateDeliverySettingsChangeSettingsThunk } from '../../../../redux/thunk/deliverySettings'

const DeliveryChangeSettings = React.memo(() => {
	const { t } = useTranslation()
	const changeSettings = useSelector(store => store.deliverySettings.changeSettings)
	const dispatch = useDispatch()

	const changeChangeSetting = useCallback((e, businessScope) => {
		dispatch(updateDeliverySettingsChangeSettingsThunk({
			businessScope,
			module: DELIVERY_MODULE,
			showCalculatorWithChange: e.target.checked,
		}))
	}, [dispatch])


	return (
		<CartSettingContent>
			<CartSettingTitle>{t('Settings.TextChangeSettings')}</CartSettingTitle>
			<CartSettingSwitchWrap>
				{businessScopeConfig.map((config, index) => {
					const businessScope = config.businessScope
					const setting = changeSettings.find(item => item.businessScope === businessScope)
					const isActive = setting?.showCalculatorWithChange
					const layout = isActive ? 'active' : ''
					return (
						<CartSettingSwitchItem key={index} className={layout}>
							<SwitchInputControlled name={`enabled-${businessScope}-change-calculator`}
																		 testId={`enabled-${businessScope}-change-calculator`}
																		 checked={isActive}
																		 onChange={e => changeChangeSetting(e, businessScope)}
																		 label={t(config.title)} />
						</CartSettingSwitchItem>
					)
				})}
			</CartSettingSwitchWrap>
		</CartSettingContent>
	)
})

DeliveryChangeSettings.displayName = 'DeliveryChangeSettings'
export default DeliveryChangeSettings
